import React, { useState } from "react";

import ChartComponent from "components/molecules/Chart/Chart2";
import * as htmlToImage from "html-to-image";

import { Subtitle } from "components/atoms/Subtitle/Subtitle";
import BorderButton from "components/atoms/BorderButton/BorderButton";
import SummaryList from "components/molecules/SummaryList/SummaryList";
import { Container } from "components/atoms/Container/Container";
import { RedBar } from "components/atoms/RedBar/RedBar";
import { CostParagraph } from "components/atoms/CostParagraph/CostParagraph";
import ClearButton from "components/atoms/ClearButton/ClearButton";
import RedButton from "components/atoms/RedButton/RedButton";

import {
  SummaryFormWrapper,
  SummaryCostParagraph,
  Paragraph,
  ButtonsWrapper,
  ChartWrapper,
} from "views/Step4.styles";
import Step4Data from "data/Step4Data";
import GlobalData from "data/GlobalData";
import { PdfGeneratorAndSubmit } from "helpers/PdfGeneratorAndSubmit";
import Modal from "components/organisms/Modal/Modal";
const Step4 = ({
  summary,
  filledFields,
  priceValue,
  lang,
  setStep,
  setFilledFields,
  setPrice,
  setSummary,
  setSelectedChallenges,
  scrollToTopOfApp,
}) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [checkboxError, setCheckboxError] = useState("");
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [sent, setsSent] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chartImage, setChartImage] = useState(null);
  const validateEmail = (email) => {
    if (email === "") {
      setEmailError(
        lang === "pl"
          ? GlobalData.validation.email1.pl
          : GlobalData.validation.email1.en
      );
    } else if (!email.includes("@")) {
      setEmailError(
        lang === "pl"
          ? GlobalData.validation.email2.pl
          : GlobalData.validation.email2.en
      );
    } else {
      setEmailError(null);
    }
  };

  const validateCheckbox = (isChecked) => {
    if (!isChecked) {
      setCheckboxError(true);
    } else {
      setCheckboxError(false);
    }
  };
  function handleCheckboxChange(e) {
    const isChecked = e.target.checked;
    setCheckboxChecked(isChecked);
    validateCheckbox(isChecked);
    const generateChartImage = async () => {
      let chartImage;
      if (window.innerWidth < 820) {
        chartImage = null;
      } else {
        try {
          const options = {
            pixelRatio: 4,
          };
          chartImage = await htmlToImage.toPng(
            document.getElementById("my-chart"),
            options
          );
          setChartImage(chartImage);
        } catch (error) {
          console.error("Error generating chart image:", error);
        }
      }
    };
    generateChartImage();
  }
  function handleInputChange(e) {
    setEmail(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    validateEmail(email);
    validateCheckbox(checkboxChecked);
    if (!emailError && checkboxChecked) {
      PdfGeneratorAndSubmit(
        lang,
        priceValue,
        roi,
        summary,
        Acalc,
        Bcalc,
        Ccalc,
        Dcalc,
        Ecalc,
        email,
        chartImage
      );
      setsSent(true);
      const listItems = summary.map(({ challenge, inputs }) => {
        if (challenge.id === "A") {
          const itemElements = inputs.map(
            (field) =>
              `<li>${field.label} ${
                field.unit === "PLN" || field.unit === "EUR"
                  ? Number(field.value).toLocaleString(
                      field.unit === "PLN" ? "pl-PL" : "de-DE",
                      {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  : field.value
              }${field.unit === "PLN" || field.unit === "EUR" ? " " : ""}${
                field.unit
              }</li>`
          );
          return `<div>
              <h2>${challenge.name}</h2>
                <ul>
                  ${itemElements.join("")}
                </ul>
              <h3>
              ${
                lang === "pl" ? Step4Data.atitle.pl : Step4Data.atitle.en
              } ${Acalc.toLocaleString("pl-PL", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
              </h3>
            </div>
            `;
        }
        if (challenge.id === "B") {
          const itemElements = inputs.map(
            (field) =>
              `<li>${field.label} ${
                field.unit === "PLN" || field.unit === "EUR"
                  ? Number(field.value).toLocaleString(
                      field.unit === "PLN" ? "pl-PL" : "de-DE",
                      {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  : field.value
              }${field.unit === "PLN" || field.unit === "EUR" ? " " : ""}${
                field.unit
              }</li>`
          );
          return `<div>
              <h2>${challenge.name}</h2>
                <ul>
                  ${itemElements.join("")}
                </ul>
              <h3>
              ${
                lang === "pl" ? Step4Data.btitle.pl : Step4Data.btitle.en
              } ${Bcalc.toLocaleString("pl-PL", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
              </h3>
            </div>
            `;
        }
        if (challenge.id === "C") {
          const itemElements = inputs.map(
            (field) =>
              `<li>${field.label} ${
                field.unit === "PLN" || field.unit === "EUR"
                  ? Number(field.value).toLocaleString(
                      field.unit === "PLN" ? "pl-PL" : "de-DE",
                      {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  : field.value
              }${field.unit === "PLN" || field.unit === "EUR" ? " " : ""}${
                field.unit
              }</li>`
          );
          return `<div>
              <h2>${challenge.name}</h2>
                <ul>
                  ${itemElements.join("")}
                </ul>
              <h3>
              ${
                lang === "pl" ? Step4Data.ctitle.pl : Step4Data.ctitle.en
              } ${Ccalc.toLocaleString("pl-PL", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
              </h3>
            </div>
            `;
        }
        if (challenge.id === "D") {
          const itemElements = inputs.map(
            (field) =>
              `<li>${field.label} ${
                field.unit === "PLN" || field.unit === "EUR"
                  ? Number(field.value).toLocaleString(
                      field.unit === "PLN" ? "pl-PL" : "de-DE",
                      {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  : field.value
              }${field.unit === "PLN" || field.unit === "EUR" ? " " : ""}${
                field.unit
              }</li>`
          );
          return `<div>
              <h2>${challenge.name}</h2>
                <ul>
                  ${itemElements.join("")}
                </ul>
              <h3>
              ${
                lang === "pl" ? Step4Data.dtitle.pl : Step4Data.dtitle.en
              } ${Dcalc.toLocaleString("pl-PL", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
              </h3>
            </div>
            `;
        }
        if (challenge.id === "E") {
          const itemElements = inputs.map(
            (field) =>
              `<li>${field.label} ${
                field.unit === "PLN" || field.unit === "EUR"
                  ? Number(field.value).toLocaleString(
                      field.unit === "PLN" ? "pl-PL" : "de-DE",
                      {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  : field.value
              }${field.unit === "PLN" || field.unit === "EUR" ? " " : ""}${
                field.unit
              }</li>`
          );
          return `<div>
              <h2>${challenge.name}</h2>
                <ul>
                  ${itemElements.join("")}
                </ul>
              <h3>
              ${
                lang === "pl" ? Step4Data.etitle.pl : Step4Data.etitle.en
              } ${Ecalc.toLocaleString("pl-PL", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
              </h3>
            </div>
            `;
        }
        return "";
      });

      const summarypost = `
      <h2>
      ${lang === "pl" ? Step4Data.redbar.pl : Step4Data.redbar.en}
    </h2>
    <p>
    ${lang === "pl" ? Step4Data.pricetext.pl : Step4Data.pricetext.en} ${
        priceValue
          ? Number(priceValue).toLocaleString(
              lang === "pl" ? "pl-PL" : "de-DE",
              {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )
          : 0
      } ${lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
    </p>
      <h3>
      ${lang === "pl" ? Step4Data.roi.pl : Step4Data.roi.en} <span className=${
        roi.toFixed(2) <= 36 ? "green" : ""
      }> ${
        roi
          ? roi.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : 0
      } (${lang === "pl" ? Step4Data.month.pl : Step4Data.month.en})
        </span>
      </h3>
      `;
      const newPost = {
        title: `${email}`,
        content: `<div>${listItems}</div><div>${summarypost}</div>`,
        status: "publish",
      };
      fetch("https://mv-center.com/wp-json/wp/v2/roi", {
        method: "POST",
        headers: {
          Authorization: "Basic " + btoa("redaktor:gTCKyefVl6GKEcg91Yai2sSG"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newPost),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("New post created");
        })
        .catch((error) => {
          console.error("Error creating post:", error);
        });
    }
  }

  function handleFix() {
    scrollToTopOfApp();
    setStep(1);
  }
  function handleAgain() {
    scrollToTopOfApp();
    setShowModal(true);
  }
  const Acalc =
    filledFields.A1 * filledFields.A2 * filledFields.A3 * filledFields.A4 * 8;
  const Bcalc = filledFields.B1 * (filledFields.B2 / 100) * filledFields.B3;
  const Ccalc =
    Number(filledFields.C1 * filledFields.C2) +
    Number(filledFields.C1 * filledFields.C3);
  const Dcalc = filledFields.D1 * (filledFields.D2 / 100) * filledFields.D3;
  const Ecalc =
    (Number(filledFields.E1) + Number(filledFields.E2)) * filledFields.E3;

  const targetIds = ["A", "B", "C", "D", "E"];
  const challenges = {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
  };

  summary.forEach((item) => {
    const id = item.challenge.id;
    if (targetIds.includes(id)) {
      challenges[id] = 1;
    } else {
      challenges[id] = 0;
    }
  });

  const roi =
    Number(priceValue) /
    ((typeof Dcalc !== "undefined" && !isNaN(Dcalc) ? Number(Dcalc) : 0) *
      challenges.D +
      (challenges.C *
        (typeof Ccalc !== "undefined" && !isNaN(Ccalc) ? Number(Ccalc) : 0)) /
        12 +
      challenges.B *
        (typeof Bcalc !== "undefined" && !isNaN(Bcalc) ? Number(Bcalc) : 0) +
      challenges.A *
        Number(
          typeof Acalc !== "undefined" && !isNaN(Acalc) ? Number(Acalc) : 0
        ) +
      ((typeof Ecalc !== "undefined" && !isNaN(Ecalc) ? Number(Ecalc) : 0) /
        12) *
        challenges.E);

  return (
    <Container>
      <Subtitle>
        {lang === "pl" ? Step4Data.subtitle.pl : Step4Data.subtitle.en}
      </Subtitle>
      {summary &&
        summary.map(({ challenge, inputs }, index) => {
          if (challenge.id === "A") {
            return (
              <div key={index}>
                <RedBar>{challenge.name}</RedBar>
                <SummaryList inputs={inputs} />
                <CostParagraph>
                  {lang === "pl" ? Step4Data.atitle.pl : Step4Data.atitle.en}
                  &nbsp;
                  {Acalc.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
                <CostParagraph>
                  {lang === "pl" ? Step4Data.atitley.pl : Step4Data.atitley.en}
                  &nbsp;
                  {(Acalc * 12).toLocaleString(
                    lang === "pl" ? "pl-PL" : "de-DE",
                    {
                      style: "decimal",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
              </div>
            );
          }
          if (challenge.id === "B") {
            return (
              <div key={index}>
                <RedBar>{challenge.name}</RedBar>
                <SummaryList inputs={inputs} />
                <CostParagraph>
                  {lang === "pl" ? Step4Data.btitle.pl : Step4Data.btitle.en}
                  &nbsp;
                  {Bcalc.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
                <CostParagraph>
                  {lang === "pl" ? Step4Data.btitley.pl : Step4Data.btitley.en}
                  &nbsp;
                  {(Bcalc * 12).toLocaleString(
                    lang === "pl" ? "pl-PL" : "de-DE",
                    {
                      style: "decimal",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
              </div>
            );
          }
          if (challenge.id === "C") {
            return (
              <div key={index}>
                <RedBar>{challenge.name}</RedBar>
                <SummaryList inputs={inputs} />
                <CostParagraph>
                  {lang === "pl" ? Step4Data.ctitle.pl : Step4Data.ctitle.en}
                  &nbsp;
                  {Ccalc.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
              </div>
            );
          }
          if (challenge.id === "D") {
            return (
              <div key={index}>
                <RedBar>{challenge.name}</RedBar>
                <SummaryList inputs={inputs} />
                <CostParagraph>
                  {lang === "pl" ? Step4Data.dtitle.pl : Step4Data.dtitle.en}
                  &nbsp;
                  {Dcalc.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
                <CostParagraph>
                  {lang === "pl" ? Step4Data.dtitley.pl : Step4Data.dtitley.en}
                  &nbsp;
                  {(Dcalc * 12).toLocaleString(
                    lang === "pl" ? "pl-PL" : "de-DE",
                    {
                      style: "decimal",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
              </div>
            );
          }
          if (challenge.id === "E") {
            return (
              <div key={index}>
                <RedBar>{challenge.name}</RedBar>
                <SummaryList inputs={inputs} />
                <CostParagraph>
                  {lang === "pl" ? Step4Data.etitle.pl : Step4Data.etitle.en}
                  &nbsp;
                  {Ecalc.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                </CostParagraph>
              </div>
            );
          } else {
          }
          return <></>;
        })}

      <RedBar>
        {lang === "pl" ? Step4Data.redbar.pl : Step4Data.redbar.en}
      </RedBar>
      <CostParagraph>
        {lang === "pl" ? Step4Data.pricetext.pl : Step4Data.pricetext.en}{" "}
        {priceValue
          ? Number(priceValue).toLocaleString(
              lang === "pl" ? "pl-PL" : "de-DE",
              {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )
          : 0}
        &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
      </CostParagraph>
      <ChartWrapper id="my-chart">
        <ChartComponent
          lang={lang}
          priceValue={priceValue}
          Acalc={Acalc}
          Bcalc={Bcalc}
          Ccalc={Ccalc}
          Dcalc={Dcalc}
          Ecalc={Ecalc}
          roi={roi}
        />
      </ChartWrapper>
      <SummaryFormWrapper>
        <SummaryCostParagraph>
          {lang === "pl" ? Step4Data.roi.pl : Step4Data.roi.en}{" "}
          <span className={roi.toFixed(2) <= 36 ? "green" : ""}>
            {roi
              ? roi.toLocaleString(lang === "pl" ? "pl-PL" : "de-DE", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : 0}{" "}
            ({lang === "pl" ? Step4Data.month.pl : Step4Data.month.en})
          </span>
        </SummaryCostParagraph>
        <Paragraph>
          {lang === "pl" ? Step4Data.give.pl : Step4Data.give.en}
        </Paragraph>

        <form onSubmit={handleSubmit} noValidate>
          <input
            onChange={handleInputChange}
            value={email || ""}
            type="email"
            placeholder={
              lang === "pl"
                ? GlobalData.placeholder.email.pl
                : GlobalData.placeholder.email.en
            }
          />
          {emailError && <p className="error">{emailError}</p>}
          <div className="checkbox-wrapper">
            <label className={checkboxError ? "error" : ""} htmlFor="checkid">
              <input
                id="checkid"
                name="checkid"
                type="checkbox"
                required
                checked={checkboxChecked}
                onChange={handleCheckboxChange}
              />
              <span
                dangerouslySetInnerHTML={{
                  __html: lang === "pl" ? Step4Data.rodo.pl : Step4Data.rodo.en,
                }}
              ></span>
            </label>
          </div>
          <ButtonsWrapper>
            <BorderButton onClick={() => handleFix()}>
              {lang === "pl"
                ? GlobalData.buttons.backEdit.pl
                : GlobalData.buttons.backEdit.en}
            </BorderButton>
            <RedButton disabled={!email} type="submit">
              {lang === "pl"
                ? GlobalData.buttons.send.pl
                : GlobalData.buttons.send.en}
            </RedButton>
          </ButtonsWrapper>
          {sent && (
            <p className="sent green">
              {lang === "pl" ? Step4Data.msgsend.pl : Step4Data.msgsend.en}
            </p>
          )}
        </form>
        <ClearButton onClick={() => handleAgain()}>
          {lang === "pl" ? Step4Data.clear.pl : Step4Data.clear.en}
        </ClearButton>
      </SummaryFormWrapper>
      {showModal && (
        <Modal
          setFilledFields={setFilledFields}
          setStep={setStep}
          setShowModal={setShowModal}
          setSummary={setSummary}
          setSelectedChallenges={setSelectedChallenges}
          setPrice={setPrice}
          lang={lang}
          scrollToTopOfApp={scrollToTopOfApp}
        />
      )}
    </Container>
  );
};

export default Step4;
